module.exports = __webpack_public_path__ + "front/img/b26_1.538871f9.jpg";